import { EmailNotConnected } from './EmailNotConnected';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCallback } from 'react';
import { ShareToolFormContainer, ShareToolTabLeftSection, ShareToolTabRightSection } from './ShareToolLayout';
import { ToField } from './ToField';
import { CcField } from './CcField';
import { FromField } from './FromField';
import { EmailPreview } from './EmailPreview';
import { ShareToolTabFooter } from './ShareToolTabFooter';
import { SendEmailButton } from './SendEmailButton';
import { SubjectField } from './SubjectField';
import { BodyField } from './BodyField';
import { WriteManualEmailButton } from './WriteManualEmailButton';
import { AttachPdfField } from './AttachPdfField';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { trackInteraction } from '../../usage-tracker/track';
import { useEmailShareTabContext } from '../../context/EmailShareTabContext';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmailShareTab = ({
  emailNotConnectedDescription,
  emailSettingsConfig,
  sendEmailButtonLabel,
  attachPdfFieldLabel,
  manualEmailButtonConfig,
  aiGenerateEmailButtonConfig,
  sendEmail,
  initialValues
}) => {
  var _initialValues$ccCont, _initialValues$ccCont2;
  const {
    connectedEmails,
    connectedEmailsLoading,
    refetchConnectedEmails,
    selectedFromValue,
    sendEmailError,
    isCcButtonClicked,
    updateIsCcButtonClicked
  } = useEmailShareTabContext();
  const handleCcButtonClick = useCallback(() => {
    trackInteraction({
      action: 'click add cc button'
    });
    updateIsCcButtonClicked(true);
  }, [updateIsCcButtonClicked]);
  if (connectedEmailsLoading || connectedEmails.length && !selectedFromValue) {
    return /*#__PURE__*/_jsx(Flex, {
      alignSelf: "center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }
  if (!connectedEmails.length) {
    return /*#__PURE__*/_jsx(EmailNotConnected, {
      description: emailNotConnectedDescription,
      onConnect: refetchConnectedEmails
    });
  }
  const showCcField = ((_initialValues$ccCont = initialValues === null || initialValues === void 0 || (_initialValues$ccCont2 = initialValues.ccContacts) === null || _initialValues$ccCont2 === void 0 ? void 0 : _initialValues$ccCont2.length) !== null && _initialValues$ccCont !== void 0 ? _initialValues$ccCont : 0) > 0 || isCcButtonClicked;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    blockSize: "auto",
    inlineSize: "100%",
    children: [sendEmailError && /*#__PURE__*/_jsx(Box, {
      shrink: 0,
      basis: "100%",
      paddingBlockEnd: "600",
      children: /*#__PURE__*/_jsx(Alert, {
        titleText: sendEmailError.titleText,
        type: "danger",
        children: sendEmailError.message
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      minBlockSize: "0",
      flexBasis: "100%",
      children: [/*#__PURE__*/_jsx(ShareToolTabLeftSection, {
        children: /*#__PURE__*/_jsxs(ShareToolFormContainer, {
          children: [/*#__PURE__*/_jsx(ToField, {}), showCcField ? /*#__PURE__*/_jsx(CcField, {}) : /*#__PURE__*/_jsx(View, {
            marginBlockStart: "200",
            marginBlockEnd: "200",
            as: "div",
            children: /*#__PURE__*/_jsx(Link, {
              onClick: handleCcButtonClick,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "CommerceToolsUiLib.shareToolModal.emailTab.addCcButtonLabel"
              })
            })
          }), /*#__PURE__*/_jsx(FromField, {
            emailSettingsConfig: emailSettingsConfig
          }), /*#__PURE__*/_jsx(SubjectField, {
            aiGenerateEmailButtonConfig: aiGenerateEmailButtonConfig
          }), /*#__PURE__*/_jsx(BodyField, {}), /*#__PURE__*/_jsx(AttachPdfField, {
            label: attachPdfFieldLabel
          })]
        })
      }), /*#__PURE__*/_jsx(ShareToolTabRightSection, {
        children: /*#__PURE__*/_jsx(EmailPreview, {})
      }), /*#__PURE__*/_jsxs(ShareToolTabFooter, {
        children: [/*#__PURE__*/_jsx(SendEmailButton, {
          label: sendEmailButtonLabel,
          sendEmail: sendEmail
        }), manualEmailButtonConfig && /*#__PURE__*/_jsx(WriteManualEmailButton, Object.assign({}, manualEmailButtonConfig))]
      })]
    })]
  });
};